

























































































import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { UpgradeJob, UpgradeJobType } from '@/types/upgradejob';
import { UpgradeReportType } from '@/types/upgradereporttype';
import { Cycle } from '@/types/cycle';
import { upgradeJobTabs } from '@/types/upgradejobtabs';

@Component({
  name: 'qual-rewards-and-linked-accounts-comparison-job-form',
  props: {
    lastThreeCycles: Array,
    qualificationsReportHistory: Array,
    rewardsReportHistory: Array,
    linkedAccountsReportHistory: Array,
    currentlySelectedFiId: Number,
    jobOnThisTabRunning: Boolean,
  },
})
export default class QualRewardsAndLinkedAccountsComparisonJobForm extends Vue {
	UpgradeReportType = UpgradeReportType;

	upgradeJobTabs = upgradeJobTabs;

	interestValidation:string = 'false';

	selectedCycleId:string = '';

	cycleMap:Map<string, Cycle> = new Map();

	isJobOnThisTabRunning() {
	  return this.$props.jobOnThisTabRunning;
	}

	@Watch('lastThreeCycles')
	updateCycleData() {
	  this.cycleMap = new Map();
	  this.$props.lastThreeCycles.forEach((cycle:any) => {
	    this.cycleMap.set(cycle.id, cycle);
	  });
	}

	@Watch('selectedCycleId')
	onSelectedCycleDropDate() {
	  this.$emit('statementDropDateSelected', UpgradeReportType.QUALIFICATIONS);
	  this.$emit('statementDropDateSelected', UpgradeReportType.REWARDS);
	  this.$emit('statementDropDateSelected', UpgradeReportType.LINKED_ACCOUNTS);
	}

	emitRunSelectedReport() {
	  this.$emit('runSelectedUpgradeJob',
	    UpgradeJobType.QUALIFICATIONS,
	    '/api/krp/admin/upgrade/qualifications',
	    {
	      dropDate: this.cycleMap.get(this.selectedCycleId)!.dropDate,
	      fiId: this.$props.currentlySelectedFiId,
      				});
	  this.$emit('runSelectedUpgradeJob',
	    UpgradeJobType.REWARDS,
	    '/api/krp/admin/upgrade/rewards',
	    {
	      dropDate: this.cycleMap.get(this.selectedCycleId)!.dropDate,
	      fiId: this.$props.currentlySelectedFiId,
	      interestValidation: this.interestValidation,
      				});
	  this.$emit('runSelectedUpgradeJob',
	    UpgradeJobType.LINKED_ACCOUNTS,
	    '/api/krp/admin/upgrade/linked-accounts',
	    {
	      fiId: this.$props.currentlySelectedFiId,
      				});
	}

	areNoReportsForSelectedFi() {
	  return 	this.$props.qualificationsReportHistory
				&& this.$props.qualificationsReportHistory.length === 0
				&& this.selectedCycleId.length !== 0;
	}

	areQualificationsReportsLoaded() {
	  return this.$props.qualificationsReportHistory
			&& this.$props.qualificationsReportHistory.length !== 0;
	}

	areRewardsReportsLoaded() {
	  return this.$props.rewardsReportHistory
			&& this.$props.rewardsReportHistory.length !== 0;
	}

	areLinkedAccountComparisonReportsLoaded() {
	  return this.$props.linkedAccountsReportHistory
			&& this.$props.linkedAccountsReportHistory.length !== 0;
	}

	shouldDisableRunReportButton() {
	  return this.selectedCycleId.length === 0;
	}

	emitDownloadReport(reportType:string, s3Key:string, versionId:string) {
	  this.$emit('downloadPreviousReportVersion', reportType, s3Key, versionId);
	}
}
